export default defineNuxtPlugin(() => {
  const router = useRouter();

  // Nuxt's built-in reload only covers route navigation; this also covers lazy component chunks missing after a deploy.
  // reloadNuxtApp itself prevents reload loops for the same path.
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadNuxtApp({ path: router.currentRoute.value.fullPath, persistState: false });
  });
});
